import { Http } from "../../../../../../helpers/axois";
import *  as _ from 'lodash';
import { isValidFuncName } from "../../../../../marketplace/apps/helpers";

export async function getFunctions(appId: string, versionId: string) {
    return new Promise((resolve, reject) => {
        Http.get(`/apps/${appId}/functions?versionId=${versionId}`).subscribe((funcRes: any) => {
            if (funcRes && funcRes.length > 0) {
                let functionsName = ``;
                
                 // invalid function names omitted to studio intelisense
                _.each(funcRes, (c) => {
                    if (isValidFuncName(c.name)) {
                        functionsName += `${c.name}(params: Object): Promise<any>\n`
                    }
                })
                if (functionsName.length > 0) {
                    resolve(`
                    interface Ia8func {
                        ${functionsName}
                    };
                    declare var bindParams: any;
                    declare var a8func: Ia8func;
                `)
                }
            } else {
                resolve(`
                declare var a8func: {}
                `)
            }
        }, () => {
            resolve(`
            declare var a8func: {}
            `)
        });
    })
}